import { getMarkRange, mergeAttributes } from '@tiptap/core'
import TiptapLink, { type LinkOptions } from '@tiptap/extension-link'
import { Plugin, TextSelection } from '@tiptap/pm/state'
import { EditorView } from '@tiptap/pm/view'

export const Link = TiptapLink.extend({
    inclusive: false,

    parseHTML() {
        return [
            {
                tag: 'a[href]:not([data-type="button"]):not([href *= "javascript:" i])',
            },
        ]
    },

    renderHTML({ HTMLAttributes }: { HTMLAttributes: Record<string, unknown> }) {
        return ['a', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0]
    },

    addOptions() {
        return {
            ...super.addOptions?.(),
            protocols: ['http', 'https', 'mailto'],
            isAllowedUri: ((url, ctx) => {
                return ctx.defaultValidate(url) && !url.startsWith('./')
            }) satisfies LinkOptions['isAllowedUri'],
            openOnClick: false,
            HTMLAttributes: {
                class: 'link',
            },
        }
    },

    addProseMirrorPlugins() {
        const { editor } = this

        return [
            ...(super.addProseMirrorPlugins?.() || []),
            new Plugin({
                props: {
                    handleKeyDown: (_: EditorView, event: KeyboardEvent) => {
                        const { selection } = editor.state

                        if (event.key === 'Escape' && !selection.empty) {
                            editor.commands.focus(selection.to, { scrollIntoView: false })
                        }

                        return false
                    },

                    handleClick(view, pos) {
                        const { schema, doc, tr } = view.state
                        const range = getMarkRange(doc.resolve(pos), schema.marks.link)

                        if (!range) return

                        const { from, to } = range
                        if (pos < from || pos > to) return

                        const $from = doc.resolve(from)
                        const $to = doc.resolve(to)
                        const transaction = tr.setSelection(new TextSelection($from, $to))
                        view.dispatch(transaction)
                    },
                },
            }),
        ]
    },
})

export default Link
